const checkGifts = class {

    constructor() {
        const elJsonNode = document.querySelector('[data-checkout-gifts]');
        const elJsonNodeText = elJsonNode.textContent;
        try {
            const data = JSON.parse(elJsonNodeText);
            this.conditions = data.conditions;
            this.i18n = data.i18n;
        } catch (error) {
            this.conditions = [];
        }
        this.allBlockID = [];
        this.hasTagsList = false;
        this.isCheckout = Shopify && Shopify.Checkout;
    }

    init(e) {
        if (this.isCheckout) {
            this.checkTagsList(e);
            this.bindInputCodeField();
        }
        this.handleConditions();
        document.addEventListener('check:checkout-gifts', e => {
           
            this.handleConditions(e);
        });
    }

    async fetchCart(cb) {
        let cart = await fetch('/cart.json', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async r => await r.json());
        if ("function" == typeof cb) {
            cb(cart);
        } else {
            return cart;
        }
    }
    
    async asyncFetchProduct(handle, cb) {
        let product;
        const res = await fetch('/products/'+handle+'.json', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async r => r && r.ok ? await r.json() : null);
        if (res && res.product) {
            product = res.product;
        }
        if ("function" == typeof cb) {
            cb(product);
        } else {
            return product;
        }
    }

    async updateCart(updates, cb) {
       
        let item = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
        }).then(async r => await r.json());
        if ("function" == typeof cb) {
            cb(item);
        } else {
            return item;
        }
    };

    async addToCart(items, cb) {
     
        items = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: items })
        }).then(async r => await r.json());
        if ("function" == typeof cb) {
            cb(items);
        } else {
            return items;
        }
    };

    checkTagsList(e) {
        if (e && e.relatedNode.classList.contains('order-summary__sections')) {
            this.elOrderSummary = e.relatedNode;
            this.elTagsList = this.elOrderSummary.querySelector('.order-summary__section .tags-list');
            this.elTagsListWrapper = document.querySelector('.tags-list-wrapper');
            this.elTriggerSummaryToggle = document.querySelector('.trigger-summary-toggle-wrapper');
            if (this.elTagsList) {
                if (!this.hasTagsList) {
                    hasTagsList = true;
                    return;
                }
            }
            this.hasTagsList = false;
        }
    }

    bindInputCodeField() {
        const elCodeInputField = document.querySelector('[id="checkout_reduction_code"]');
        if (elCodeInputField) {
            const elCodeForm = elCodeInputField.closest('form');
            const elCodeFormSubmitBtn = elCodeForm.querySelector('button[type="submit"]');
            elCodeFormSubmitBtn.addEventListener('click', function(e) {
                e.preventDefault();
                if (e.target.nodeName == 'BUTTON') {
                    e.target.classList.add('btn--loading');
                }
                const params = new URLSearchParams(location.search);
                params.set('discount', elCodeInputField.value);
                location.href = location.origin + location.pathname + '?' + params.toString();
            })
            elCodeForm.addEventListener('submit', function(e) {
                e.preventDefault();
                return false;
            });
        }
    }

    showReloadingBanner() {
        document.body.insertAdjacentHTML('afterbegin', `<div class="loading-curtain">${this.i18n['shopify.checkout.general.please_wait']}</div>`);
    }

    triggerCartRedraw(e) {
      
        if (e.Cart) {
            $.get('/cart?view=ajax').done(function (data) {
                $('[data-cart-additional-gift]').hide().appendTo('[data-cart-gift-holder]');
                $('[data-cart-additional]').slideUp().appendTo('[data-cart-holder]');
                $('[data-cart-form-wrapper]').empty().html(data);
                $('[data-cart-additional]').appendTo('[data-additional-insert]').slideDown('slow');
                $('[data-cart-additional-gift]').appendTo('[data-allow_gift_wrapping]').show();
                e.Cart.init();
            });
        }
    }

    async handleConditions(e) {
        var _this = this;
    
        let reloadLocationNecessary = false, discountToAppend;
        const elNoticeText = document.querySelector('.notice--warning .notice__text');
        const itemsRemoveCart = {}, itemsAddCart = [];
        this.cart = await this.fetchCart();
 ;

        if (this.cart.items.length > 0 && this.cart.total_price == 0) {
          
            $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                success: function(){
               
                    location.reload();
                },
                dataType: 'json'
            });
           
            return;
        } else if (this.cart.items.length == 0 && this.cart.total_price == 0 && document.querySelector("#CartForm")) {
      
            location.reload();
        }

        if (this.conditions.length) {

            await Promise.all(

                this.conditions.map(
                    async condition => {
                    
                        let is_active = condition.is_active,
                            needs_code = condition.needs_code,
                            free_by_code = condition.free_by_code,
                            code = condition.code,
                            product = condition.product,
                            productVariantId = condition.productVariantId,
                            minCartValue = condition.minCartValue,
                            maxCartValue = condition.maxCartValue,
                            discountLabel = condition.discountLabel,
                            conditionIsMet = false,
                            productAlreadyInCart = false,
                            productAlreadyInCartKey = null,
                            themeSettingCodeBlockId = condition.theme_setting_code_block_id;

                    
                        this.allBlockID.push(themeSettingCodeBlockId);
                        //TODO check if Block_id CONTENT is change example to change "condition.discountLabel"
                        if (!is_active) {
                            
                            if (!product) {
                                product = await this.asyncFetchProduct(condition.productHandle);
                                productVariantId = product ? product.variants[0].id : null;
                            }

                            if (product) {
                                
                                this.cart.items.find(function (item) {

                                    if (item.properties && item.properties._cart_checkout_gift && item.properties._code_block_id == themeSettingCodeBlockId) {
                                        
                                         if (item.variant_id != productVariantId) {
                                          
                                            itemsRemoveCart[item.variant_id] = 0;
                                        }

                                        if (item.variant_id == productVariantId) {

                                         
                                            itemsRemoveCart[productVariantId] = 0;
                                        }

                                        if (needs_code && !item.properties._cart_checkout_gift_code) {
                                         
                                            itemsRemoveCart[productVariantId] = 0;
                                        }
                                    }

                                });
                            }
                            
                            return true;
                        }
    
                        if (!product) {
                            product = await this.asyncFetchProduct(condition.productHandle);
                            productVariantId = product ? product.variants[0].id : null;
                        }
    
                        if (product) {
                            this.cart.items.find(function (item) {

                                if (item.properties && item.properties._cart_checkout_gift && item.properties._code_block_id == themeSettingCodeBlockId) {

                                    if (item.variant_id != productVariantId) {
                                        itemsRemoveCart[item.variant_id] = 0;
                                    }
                               
                                    if (item.variant_id == productVariantId) {
                                       
                                        productAlreadyInCart = true;
                                        productAlreadyInCartKey = item.key;
                                        if (item.quantity > 1) {
                                            itemsRemoveCart[productVariantId] = 1;
                                        }
                                    }

                                    if (needs_code && !item.properties._cart_checkout_gift_code) {
                                      
                                        itemsRemoveCart[productVariantId] = 0;
                                    }
                                }
                            });
    
                            if (minCartValue != null && maxCartValue == null) {
                                if (this.cart.total_price >= minCartValue) {
                                    conditionIsMet = true;
                                } else {
                                    conditionIsMet = false;
                                }
                            } else if (minCartValue == null && maxCartValue != null) {
                                if (this.cart.total_price <= maxCartValue) {
                                    conditionIsMet = true;
                                } else {
                                    conditionIsMet = false;
                                }
                            } else if (minCartValue != null && maxCartValue != null) {
                                if (this.cart.total_price >= minCartValue && this.cart.total_price <= maxCartValue) {
                                    conditionIsMet = true;
                                } else {
                                    conditionIsMet = false;
                                }
                            } else if (minCartValue == null && maxCartValue == null) {
                                conditionIsMet = true;
                            }
    
                            if (!conditionIsMet && productAlreadyInCart) {
                                itemsRemoveCart[productAlreadyInCartKey] = 0;
                            } else if (conditionIsMet && !productAlreadyInCart) {
                                const properties = {
                                    _code_block_id: themeSettingCodeBlockId,
                                    _cart_checkout_gift: true,
                                    _cart_checkout_gift_discount_label: discountLabel
                                };
                                if (needs_code) {
                                    properties._cart_checkout_gift_code = code[0];
                                }
                                if (free_by_code) {
                                    properties._cart_checkout_gift_free_by_code = code[0];
                                    if (elNoticeText && elNoticeText.innerHTML.toUpperCase().includes(code[0])) {
                                        reloadLocationNecessary = true;
                                        discountToAppend = code[0];
                                    }
                                }
                                if (minCartValue) {
                                    properties._cart_checkout_gift_min_cart_value = parseFloat(minCartValue);
                                }
                                if (maxCartValue) {
                                    properties._cart_checkout_gift_max_cart_value = parseFloat(maxCartValue);
                                }
                                itemsAddCart.push({
                                    quantity: 1,
                                    id: productVariantId,
                                    properties: properties
                                });
                            }
                        }
                    }
                )
            );

            if (Array.isArray(this.allBlockID) && this.allBlockID.length > 0 && Array.isArray(this.cart.items) && this.cart.items.length > 0) {
                
                let _this = this;
                this.cart.items.forEach(function (item) {

                    if (item.properties && item.properties._code_block_id && !_this.allBlockID.includes(item.properties._code_block_id)) {
                        itemsRemoveCart[item.variant_id] = 0;
                    }
                });
            }
           
            // here remove and update cart
            if (Object.keys(itemsRemoveCart).length) {
                await this.updateCart(itemsRemoveCart, function (e) {

                    if (Shopify && Shopify.currentTemplate && Shopify.currentTemplate == "cart" || Shopify.Checkout) {
                    
                        _this.showReloadingBanner();
                        location.reload();
                    }
                });
            }
            if (Object.keys(itemsRemoveCart).length && !itemsAddCart.length) {
                await this.updateCart(itemsRemoveCart);
            }
            if (!Object.keys(itemsRemoveCart).length && itemsAddCart.length) {
                
                await this.addToCart(itemsAddCart, function(items) {
                    
                    if (Shopify && Shopify.currentTemplate && Shopify.currentTemplate == "cart" || Shopify.Checkout) {
                    
                        if (Object.keys(items).length > 0 && Array.isArray(items.items) && items.items.length > 0) {
                            let shouldReload = false;
                            items.items.forEach(function (item) {
                               
                               
                                if (item.properties && item.properties._code_block_id != "" && (item.properties._cart_checkout_gift_min_cart_value && !item.properties._cart_checkout_gift_free_by_code) || (item.properties._cart_checkout_gift_max_cart_value && !item.properties._cart_checkout_gift_free_by_code)) {
                                    shouldReload = true;
                                }

                                const params = new URLSearchParams(location.search);
                                let discountCode = params.get("discount");
                            
                                if (item.properties && discountCode && item.properties._cart_checkout_gift_free_by_code == discountCode) {
                                    let variantElement = document.querySelectorAll("[data-variant-id=\"" + item.variant_id + "\"] .product__price del");
                                
                                  
                                    if (variantElement.length > 0) {
                                     
                                        shouldReload = false;
                                    } else {
                                     
                                      //shouldReload = true;
                                    }
                                    
                                }
                            });
                            if (shouldReload) {
                            
                                _this.showReloadingBanner();
                                location.reload();
                            }
                        }
                    }
                });
            }
            if (Object.keys(itemsRemoveCart).length || itemsAddCart.length) {
                if (!this.isCheckout && e) {
                  
                   // this.triggerCartRedraw(e);
                }
            }

            if (reloadLocationNecessary && discountToAppend && !location.search.includes('discount=')) {
                _this.showReloadingBanner();
                const params = new URLSearchParams(location.search);
                params.set('discount', discountToAppend);
                location.href = location.origin + location.pathname + '?' + params.toString();
            }

        }
    }

} 


$(function() {
    const checkoutCheckGifts = new checkGifts();
    checkoutCheckGifts.init();

    if (this.isCheckout) {
        window.addEventListener('DOMNodeInserted', function(e) {
            checkoutCheckGifts.init(e);
        });
    }

});